import * as React from 'react';
import { Price } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';

const Subtotal = ({ label , price , currency  })=>/*#__PURE__*/ React.createElement("div", {
        className: "cart-totals__row"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "cart-totals__label"
    }, /*#__PURE__*/ React.createElement(Text, {
        component: "span"
    }, label)), /*#__PURE__*/ React.createElement("div", {
        className: "cart-totals__value"
    }, /*#__PURE__*/ React.createElement(Price, {
        value: price,
        currency: currency
    })))
;

export { Subtotal };
//# sourceMappingURL=Subtotal.js.map
